/* eslint-disable jsx-a11y/anchor-has-content, jsx-a11y/control-has-associated-label */
import type { FC, ReactElement } from "react"

import { Trans } from "react-i18next"

import type { TTranslationKeys } from "$/i18n/i18n"

import { type TScreenBreakpoints, useScreenBreakpoints } from "@/3514/hooks"
import { type TProductTypeQuery, useProductTypeQuery } from "@/3514/queries"
import { buildCssClassName, getLinkDecorationTwClasses } from "@/3514/utils"

type _TProps = {
    textKey: keyof TTranslationKeys
    isTextCentered?: boolean
    containerClassName?: string
    withBreakLineOnMobile?: boolean
}

const HelpHintExtended: FC<_TProps> = ({
    textKey,
    isTextCentered = false,
    containerClassName = String(""),
    withBreakLineOnMobile = false
}: _TProps): ReactElement => {
    const { data: productType }: TProductTypeQuery = useProductTypeQuery()

    const breakpoints: TScreenBreakpoints = useScreenBreakpoints()

    return (
        <div className={buildCssClassName({ [containerClassName]: containerClassName })}>
            <Trans
                parent="p"
                className={buildCssClassName("leading-[21px] text-[14px] text-gray-200 font-[300] text-pretty", {
                    "text-center": isTextCentered
                })}
                i18nKey={textKey as string}
                values={{ careTeam: productType.supportTeamName }}
                components={{
                    a: (
                        <a
                            href={`mailto:${productType?.supportEmail}`}
                            className={buildCssClassName(
                                "whitespace-nowrap",
                                "text-accent",
                                "hover:!text-accent",
                                "focus:!text-accent",
                                getLinkDecorationTwClasses({ color: "accent", offset: 3 })
                            )}
                        />
                    ),
                    ...(withBreakLineOnMobile && { br: breakpoints.xs ? <br /> : <span /> })
                }}
            />
        </div>
    )
}

HelpHintExtended.displayName = "HelpHintExtended"

export { HelpHintExtended }
